import { render, staticRenderFns } from "./upload-picture-zone.vue?vue&type=template&id=3176772f&scoped=true&"
import script from "./upload-picture-zone.vue?vue&type=script&lang=js&"
export * from "./upload-picture-zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3176772f",
  null
  
)

export default component.exports